import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  BarGraphList,
  PieChartList,
  Top3Location,
  Top3Alert,
  BarGraphListForAlertType,
} from "../../services/Graph";

// Thunk to fetch bar graph data based on dashboard dates
export const fetchTop3LocationGraphData = createAsyncThunk(
  "top3locationPieChart/fetchTop3LocationGraphData",
  async (_, rejectWithValue) => {
    try {
      const response = await Top3Location();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchTop3AlertGraphData = createAsyncThunk(
  "top3AlertPieChart/fetchTop3AlertGraphData",
  async (_, rejectWithValue) => {
    try {
      const response = await Top3Alert();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAlertBarGraphData = createAsyncThunk(
  "alertBarGraph/fetchAlertBarGraphData",
  async ({ startDate, startTime, endDate, endTime }, rejectWithValue) => {
    try {
      const response = await BarGraphList({
        startDate,
        startTime,
        endDate,
        endTime,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAlerPieChartData = createAsyncThunk(
  "alertPieChart/fetchAlertPieChartData",
  async ({ startDate, startTime, endDate, endTime }, rejectWithValue) => {
    try {
      const response = await PieChartList({
        startDate,
        startTime,
        endDate,
        endTime,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchAlertBarGraphDataForAlertType = createAsyncThunk(
  "alertBarGraphForAlertType/fetchAlertBarGraphDataForAlertType",
  async ({ startDate, startTime, endDate, endTime }, rejectWithValue) => {
    try {
      const response = await BarGraphListForAlertType({
        startDate,
        startTime,
        endDate,
        endTime,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const graphSlice = createSlice({
  name: "graph",
  initialState: {
    top3LocationData: [],
    top3AlertData: [],
    alertBarGraphData: [],
    alertPieChartData: [],
    alertBarGraphDataForAlertType: [],
    status: {
      top3LocationData: "idle",
      top3AlertData: "idle",
      alertBarGraphData: "idle",
      alertPieChartData: "idle",
      alertBarGraphDataForAlertType: "idle",
    },
    error: {
      top3LocationData: null,
      top3AlertData: null,
      alertBarGraphData: null,
      alertPieChartData: null,
      alertBarGraphDataForAlertType: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTop3LocationGraphData.pending, (state) => {
        state.status.top3LocationData = "loading";
        state.top3LocationData = null;
      })
      .addCase(fetchTop3LocationGraphData.fulfilled, (state, action) => {
        state.status.top3LocationData = "succeeded";
        state.top3LocationData = action.payload.data.response;
      })
      .addCase(fetchTop3LocationGraphData.rejected, (state, action) => {
        state.status.top3LocationData = "failed";
        state.top3LocationData = action.payload;
      })
      .addCase(fetchTop3AlertGraphData.pending, (state) => {
        state.status.top3AlertData = "loading";
        state.top3AlertData = null;
      })
      .addCase(fetchTop3AlertGraphData.fulfilled, (state, action) => {
        state.status.top3AlertData = "succeeded";
        state.top3AlertData = action.payload.data.response;
      })
      .addCase(fetchTop3AlertGraphData.rejected, (state, action) => {
        state.status.top3AlertData = "failed";
        state.top3AlertData = action.payload;
      })
      .addCase(fetchAlertBarGraphData.pending, (state) => {
        state.status.alertBarGraphData = "loading";
        state.alertBarGraphData = null;
      })
      .addCase(fetchAlertBarGraphData.fulfilled, (state, action) => {
        state.status.alertBarGraphData = "succeeded";
        state.alertBarGraphData = action.payload.data.response;
      })
      .addCase(fetchAlertBarGraphData.rejected, (state, action) => {
        state.status.alertBarGraphData = "failed";
        state.alertBarGraphData = action.payload;
      })
      .addCase(fetchAlerPieChartData.pending, (state) => {
        state.status.alertPieChartData = "loading";
        state.alertPieChartData = null;
      })
      .addCase(fetchAlerPieChartData.fulfilled, (state, action) => {
        state.status.alertPieChartData = "succeeded";
        state.alertPieChartData = action.payload.data.response;
      })
      .addCase(fetchAlerPieChartData.rejected, (state, action) => {
        state.status.alertPieChartData = "failed";
        state.alertPieChartData = action.payload;
      })
      .addCase(fetchAlertBarGraphDataForAlertType.pending, (state) => {
        state.status.alertBarGraphDataForAlertType = "loading";
        state.alertBarGraphDataForAlertType = null;
      })
      .addCase(
        fetchAlertBarGraphDataForAlertType.fulfilled,
        (state, action) => {
          state.status.alertBarGraphDataForAlertType = "succeeded";
          state.alertBarGraphDataForAlertType = action.payload.data.response;
        }
      )
      .addCase(fetchAlertBarGraphDataForAlertType.rejected, (state, action) => {
        state.status.alertBarGraphDataForAlertType = "failed";
        state.alertBarGraphDataForAlertType = action.payload;
      });
  },
});

export default graphSlice.reducer;
